export const set_user_role = (role) => ({
  type: 'set_user_role',
  payload: role,
});
